// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__xRXtL"};